import type { Locale } from "antd/lib/locale";
import ru from "antd/lib/locale/ru_RU";

const uzLatin: Locale = {
  locale: "uz-latn",
  Pagination: {
    items_per_page: "/ sah.",
    jump_to: "O'tish",
    jump_to_confirm: "tasdiqlash",
    page: "Sahifa",
    prev_page: "Orqaga",
    next_page: "Oldinga",
    prev_5: "Oldingi 5",
    next_5: "Keyingi 5",
    prev_3: "Oldingi 3",
    next_3: "Keyingi 3",
    page_size: "sahifa hajmi",
  },
  DatePicker: {
    lang: {
      placeholder: "Sanani tanlang",
      yearPlaceholder: "Yilni tanlang",
      quarterPlaceholder: "Chorakni tanlang",
      monthPlaceholder: "Oyni tanlang",
      weekPlaceholder: "Haftani tanlang",
      rangePlaceholder: ["Boshlanish sanasi", "Tugallanish sanasi"],
      rangeYearPlaceholder: ["Boshlanish yili", "Tugallanish yili"],
      rangeMonthPlaceholder: ["Boshlanish oyi", "Tugallanish oyi"],
      rangeWeekPlaceholder: ["Boshlanish haftasi", "Tugallanish haftasi"],
      yearFormat: "YYYY",
      dayFormat: "D",
      cellMeridiemFormat: "A",
      monthBeforeYear: true,
      locale: "uz_UZ",
      today: "Bugun",
      now: "Hozir",
      backToToday: "Bugunga qaytish",
      ok: "OK",
      clear: "Toza",
      week: "Xafta",
      month: "Oy",
      year: "Yil",
      timeSelect: "vaqtni tanlang",
      dateSelect: "sanani tanlang",
      weekSelect: "Haftani tanlang",
      monthSelect: "Oyni tanlang",
      yearSelect: "Yilni tanlang",
      decadeSelect: "O'n yilni tanlang",
      dateFormat: "M/D/YYYY",
      dateTimeFormat: "M/D/YYYY HH:mm:ss",
      previousMonth: "Oldingi oy (PageUp)",
      nextMonth: "Keyingi oy (PageDown)",
      previousYear: "O'tgan yili (Control + left)",
      nextYear: "Keyingi yil (Control + right)",
      previousDecade: "Oxirgi o'n yil",
      nextDecade: "Keyingi o'n yil",
      previousCentury: "O'tgan asr",
      nextCentury: "Keyingi asr",
      shortMonths: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "Iyn",
        "Iyl",
        "Avg",
        "Sen",
        "Okt",
        "Noy",
        "Dek",
      ],
      shortWeekDays: ["Ya", "Du", "Se", "Ch", "Pa", "Ju", "Sh"],
    },
    timePickerLocale: {
      placeholder: "Vaqtni tanlang",
      rangePlaceholder: ["Boshlanish vaqti", "Tugallanish vaqti"],
    },
  },
  TimePicker: {
    placeholder: "Vaqtni tanlang",
  },
  global: {
    placeholder: "Iltimos tanlang",
    close: "Yopish",
  },
  Table: {
    filterTitle: "Filtr",
    filterConfirm: "OK",
    filterReset: "Bekor qilish",
    filterEmptyText: "Filtrlarsiz",
    filterCheckAll: "Barcha elementlarni tanlash",
    filterSearchPlaceholder: "Filtrlarda qidiruv",
    emptyText: "Ma'lumotlar topilmadi",
    selectAll: "Barchasini tanlash",
    selectInvert: "Tanlovni aylantirish",
    selectNone: "Barcha ma'lumotlarni tozalang",
    selectionAll: "Barchasini tanlash",
    sortTitle: "Tartiblash",
    expand: "Satirni yozish",
    collapse: "Satirni yig'ish",
    triggerDesc: "Kamayish tartibida tartiblash uchun bosing",
    triggerAsc: "O'sish tartibida tartiblash uchun bosing",
    cancelSort: "Tartiblshni rad etish uchun bosing",
  },
  Tour: {
    Next: "So'ngra",
    Previous: "Ortga",
    Finish: "Tugatish",
  },
  Modal: {
    okText: "OK",
    cancelText: "Yopish",
    justOkText: "OK",
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Bekor qilish",
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Qidiruv",
    itemUnit: "elem.",
    itemsUnit: "elem.",
    remove: "Oʻchirish",
    selectAll: "Barch ma'lumotlarni tanlash",
    selectCurrent: "Joriy sahifani tanlash",
    selectInvert: "Tanlovni aylantirish",
    removeAll: "Barcha ma'lumotlarni o'chirish",
    removeCurrent: "Joriy sahifani o'chirish",
  },
  Upload: {
    uploading: "Yuklanmoqda...",
    removeFile: "Faylni o'chirish",
    uploadError: "Yuklashda xatolik yuz berdi",
    previewFile: "Faylni oldindan ko'rish",
    downloadFile: "Faylni yuklash",
  },
  Empty: {
    description: "Maʼlumot topilmadi",
  },
  Icon: {
    icon: "ikonka",
  },
  Text: {
    edit: "Tahrirlash",
    copy: "Nusxalash",
    copied: "Nusxalandi",
    expand: "Ochib qoyish",
  },
  Form: {
    optional: "(shart emas)",
    defaultValidateMessages: {
      default: "${label} maydonini tekshirishda xatolik yuz berdi",
      required: "Iltimos, ${label} kiriting",
      enum: "${label}, [${enum}] dan biri boʻlishi kerak",
      whitespace: "${label} boʻsh boʻlishi mumkin emas",
      date: {
        format: "${label} toʻgʻri sana formatida emas",
        parse: "${label} sanaga aylantirilmaydi",
        invalid: "${label} tog'ri sana emas",
      },
      types: {
        string: "${label} ${type} turi emas",
        method: "${label} ${type} turi emas",
        array: "${label} ${type} turi emas",
        object: "${label} ${type} turi emas",
        number: "${label} ${type} turi emas",
        date: "${label} ${type} turi emas",
        boolean: "${label} ${type} turi emas",
        integer: "${label} ${type} turi emas",
        float: "${label} ${type} turi emas",
        regexp: "${label} ${type} turi emas",
        email: "${label} ${type} turi emas",
        url: "${label} ${type} turi emas",
        hex: "${label} ${type} turi emas",
      },
      string: {
        len: "${label}, ${len} ta belgidan iborat boʻlishi kerak",
        min: "${label} должна быть больше или равна ${min} символов",
        max: "${label}, ${max} belgidan katta yoki teng boʻlishi kerak",
        range:
          "${label} uzunligi ${min}-${max} belgilar orasida boʻlishi kerak",
      },
      number: {
        len: "${label}, ${len} ga teng boʻlishi kerak",
        min: "${label}, ${min} dan katta yoki teng boʻlishi kerak",
        max: "${label}, ${max} dan kichik yoki teng boʻlishi kerak",
        range: "${label}, ${min}-${max} orasida boʻlishi kerak",
      },
      array: {
        len: "${label} elementlari soni ${len} ga teng boʻlishi kerak",
        min: "${label} elementlari soni ${min} dan katta yoki teng boʻlishi kerak",
        max: "${label} elementlari soni ${max} dan kam yoki teng boʻlishi kerak",
        range:
          "${label} elementlari soni ${min} va ${max} orasida boʻlishi kerak",
      },
      pattern: {
        mismatch: "${label}, ${pattern} andazasiga mos emas",
      },
    },
  },
  Image: {
    preview: "Ko‘rib chiqish",
  },
  QRCode: {
    expired: "QR-kod eskirgan",
    refresh: "Yangilash",
  },
};

const uzCyrl: Locale = {
  locale: "uz-cyrl",
  Pagination: {
    items_per_page: "/ саҳ.",
    jump_to: "Ўтиш",
    jump_to_confirm: "тасдиқлаш",
    page: "Саҳифа",
    prev_page: "Ортга",
    next_page: "Олдинга",
    prev_5: "Олдинги 5",
    next_5: "Кейинги 5",
    prev_3: "Олдинги 3",
    next_3: "Кейинги 3",
    page_size: "саҳифа ҳажми",
  },
  DatePicker: {
    lang: {
      placeholder: "Санани танланг",
      yearPlaceholder: "Йилни танланг",
      quarterPlaceholder: "Чоракни танланг",
      monthPlaceholder: "Ойни танланг",
      weekPlaceholder: "Ҳафтани танланг",
      rangePlaceholder: ["Бошланиш санаси", "Тугаш санаси"],
      rangeYearPlaceholder: ["Бошланиш йили", "Тугаш йили"],
      rangeMonthPlaceholder: ["Бошланиш ойи", "Тугаш ойи"],
      rangeWeekPlaceholder: ["Бошланиш ҳафтаси", "Тугаш ҳафтаси"],
      yearFormat: "YYYY",
      dayFormat: "D",
      cellMeridiemFormat: "A",
      monthBeforeYear: true,
      locale: "uz_UZ",
      today: "Бугун",
      now: "Ҳозир",
      backToToday: "Бугунга қайтиш",
      ok: "OK",
      clear: "Тоза",
      week: "Ҳафта",
      month: "Ой",
      year: "Йил",
      timeSelect: "вақтни танланг",
      dateSelect: "санани танланг",
      weekSelect: "Ҳафтани танланг",
      monthSelect: "Ойни танланг",
      yearSelect: "Йилни танланг",
      decadeSelect: "Ўн йилни танланг",
      dateFormat: "M/D/YYYY",
      dateTimeFormat: "M/D/YYYY HH:mm:ss",
      previousMonth: "Олдинги ой (PageUp)",
      nextMonth: "Кейинги ой (PageDown)",
      previousYear: "Ўтган йил (Control + left)",
      nextYear: "Кейинги йил (Control + right)",
      previousDecade: "Охирги ўн йил",
      nextDecade: "Кейинги ўн йил",
      previousCentury: "Ўтган аср",
      nextCentury: "Кейинги аср",
      shortMonths: [
        "Ян",
        "Фев",
        "Мар",
        "Апр",
        "Май",
        "Июн",
        "Июл",
        "Авг",
        "Сен",
        "Окт",
        "Ноя",
        "Дек",
      ],
      shortWeekDays: ["Як", "Ду", "Се", "Чо", "Па", "Жу", "Ша"],
    },
    timePickerLocale: {
      placeholder: "Вақтни танланг",
      rangePlaceholder: ["Бошланиш вақти", "Тугаш вақти"],
    },
  },
  TimePicker: {
    placeholder: "Вақтни танланг",
  },
  global: {
    placeholder: "Илтимос танланг",
    close: "Ёпиш",
  },
  Table: {
    filterTitle: "Филтр",
    filterConfirm: "OK",
    filterReset: "Бекор қилиш",
    filterEmptyText: "Филтрларсиз",
    filterCheckAll: "Барча элементларни танлаш",
    filterSearchPlaceholder: "Филтрларда қидириш",
    emptyText: "Маълумотлар топилмади",
    selectAll: "Барчасини танлаш",
    selectInvert: "Танловни айлантириш",
    selectNone: "Барча маълумотларни тозалаш",
    selectionAll: "Барчасини танлаш",
    sortTitle: "Тартиблаш",
    expand: "Сатрни ёзиш",
    collapse: "Сатрни йиғиш",
    triggerDesc: "Камайиш тартибида тартиблаш учун босинг",
    triggerAsc: "Ўсиш тартибида тартиблаш учун босинг",
    cancelSort: "Тартиблашни рад этиш учун босинг",
  },
  Tour: {
    Next: "Кейинги",
    Previous: "Ортга",
    Finish: "Тугатиш",
  },
  Modal: {
    okText: "OK",
    cancelText: "Ёпиш",
    justOkText: "OK",
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Бекор қилиш",
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Қидириш",
    itemUnit: "элем.",
    itemsUnit: "элем.",
    remove: "Ўчириш",
    selectAll: "Барча маълумотларни танлаш",
    selectCurrent: "Жорий саҳифани танлаш",
    selectInvert: "Танловни айлантириш",
    removeAll: "Барча маълумотларни ўчириш",
    removeCurrent: "Жорий саҳифани ўчириш",
  },
  Upload: {
    uploading: "Юкланмоқда...",
    removeFile: "Файлни ўчириш",
    uploadError: "Юклашда хатолик юз берди",
    previewFile: "Файлни олдиндан кўриш",
    downloadFile: "Файлни юклаб олиш",
  },
  Empty: {
    description: "Маълумот топилмади",
  },
  Icon: {
    icon: "иконка",
  },
  Text: {
    edit: "Таҳрирлаш",
    copy: "Нусхалаш",
    copied: "Нусха олинди",
    expand: "Очиш",
  },
  Form: {
    optional: "(шарт эмас)",
    defaultValidateMessages: {
      default: "${label} майдонини текширишда хатолик юз берди",
      required: "Илтимос, ${label} киритинг",
      enum: "${label}, [${enum}] дан бири бўлиши керак",
      whitespace: "${label} бўш бўлиши мумкин эмас",
      date: {
        format: "${label} тўғри сана форматида эмас",
        parse: "${label} санага айлантирилмайди",
        invalid: "${label} тўғри сана эмас",
      },
      types: {
        string: "${label} ${type} тури эмас",
        method: "${label} ${type} тури эмас",
        array: "${label} ${type} тури эмас",
        object: "${label} ${type} тури эмас",
        number: "${label} ${type} тури эмас",
        date: "${label} ${type} тури эмас",
        boolean: "${label} ${type} тури эмас",
        integer: "${label} ${type} тури эмас",
        float: "${label} ${type} тури эмас",
        regexp: "${label} ${type} тури эмас",
        email: "${label} ${type} тури эмас",
        url: "${label} ${type} тури эмас",
        hex: "${label} ${type} тури эмас",
      },
      string: {
        len: "${label}, ${len} та белгидан иборат бўлиши керак",
        min: "${label} ${min} та белгидан кам бўлмаслиги керак",
        max: "${label}, ${max} белгидан кўп бўлмаслиги керак",
        range: "${label} узунлиги ${min}-${max} белгилар орасида бўлиши керак",
      },
      number: {
        len: "${label}, ${len} га тенг бўлиши керак",
        min: "${label}, ${min} дан катта ёки тенг бўлиши керак",
        max: "${label}, ${max} дан кичик ёки тенг бўлиши керак",
        range: "${label}, ${min}-${max} орасида бўлиши керак",
      },
      array: {
        len: "${label} элементлари сони ${len} га тенг бўлиши керак",
        min: "${label} элементлари сони ${min} дан катта ёки тенг бўлиши керак",
        max: "${label} элементлари сони ${max} дан кам ёки тенг бўлиши керак",
        range:
          "${label} элементлари сони ${min} ва ${max} орасида бўлиши керак",
      },
      pattern: {
        mismatch: "${label}, ${pattern} андозасига мос эмас",
      },
    },
  },
  Image: {
    preview: "Кўриб чиқиш",
  },
  QRCode: {
    expired: "QR-код эскирган",
    refresh: "Янгилаш",
  },
};

export function getAntdLocale(locale: "uz" | "oz" | "ru") {
  switch (locale) {
    case "oz":
      return uzLatin;
    case "uz":
      return uzCyrl;
    case "ru":
      return ru;
    default:
      return ru;
  }
}
